export default __webpack_public_path__ + "static/media/resume.d4259844.svg";